import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { vendordataSelector, vendordata_updateFiles } from "reducers/vendordata/vendordata";
import axios from "axios";
import APPCONFIG from "constants/appConfig";


const CancelToken = axios.CancelToken;
var source = CancelToken.source();


const executeDownload = (base64, filename) => {
  // possibly this has to be changed of other file types are allowed
  base64 = "data:application/pdf;base64," + base64;
  var byteString = atob(base64.split(",")[1]);
  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);

  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  downloadBlob(new Blob([ab]), filename);
};

const downloadBlob = (blob, name = "file.txt") => {
  // Convert your blob into a Blob URL (a special url that points to an object in the browser's memory)
  const blobUrl = URL.createObjectURL(blob);

  // Create a link element
  const link = document.createElement("a");

  // Set link's href to point to the Blob URL
  link.href = blobUrl;
  link.download = name;

  // Append link to the body
  document.body.appendChild(link);

  // Dispatch click event on the link
  // This is necessary as link.click() does not work on the latest firefox
  link.dispatchEvent(
    new MouseEvent("click", {
      bubbles: true,
      cancelable: true,
      view: window
    })
  );

  // Remove link from body
  document.body.removeChild(link);
};

export default function FileViewer(props) {
  const vendordata = useSelector(vendordataSelector);
  const dispatch = useDispatch();


  const enableRemove = props.enableRemove;
  const enableDownload = props.enableDownload;

  if (Object.keys(vendordata.files).length == 0) {
    return;
  }

  const renderFile = (f, d, key) => {
    let myStyle = {}
    if (f.DELETE) {
      myStyle.textDecoration = "line-through";
    }

    if (enableRemove) {
      return (
        <div className="d-flex align-items-center" style={myStyle} key={"fileviewpart"+f.FILE_NAME}>
          <a key={f.FILE_NUM + "del"} href="" onClick={e => { !f.DELETE ? handleRemove(e, f) : e.preventDefault() }}>
            <i className="nav-icon material-icons">delete</i>
          </a>
          {f.FILE_NAME} {d.getDate()}/{d.getMonth() + 1}/{d.getFullYear()}
        </div>
      );

    }

    return (
      <div key={d + "/" + f.FILE_NUM + "_file" + key}>
        {f.FILE_NAME} {d.getDate()}/{d.getMonth() + 1}/{d.getFullYear()}
        <br></br>
      </div>
    );
  };

  const handleRemove = (e, f) => {
    e.preventDefault();
    dispatch(vendordata_updateFiles({ remove: true, FILE_NUM: f.FILE_NUM }));
  }

  const handleDownload = (e, f) => {
    e.preventDefault();

    source = CancelToken.source();

    const axiosConfig = {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
      cancelToken: source.token
    };

    axios
      .post(
        APPCONFIG.appBackendHostname + "api/vendormasterdata/file",
        {
          FILE_NUM: f.FILE_NUM,
          REQ_ID: f.REQ_ID
        },
        axiosConfig
      )
      .then(res => {
        //console.log(res);
        executeDownload(res.data.FILE_CONTENT, res.data.FILE_NAME);
      })
      .catch(error => {
        console.error(error);
      });
  };

  return (
    <div className="mt-4">
      {enableDownload && <b>Files attached:</b>}
      {Object.keys(vendordata.files).map(key => {
        let f = vendordata.files[key];

        let d = "";
        if (f.CHG_DATE.length != 8) {
          d = new Date(parseInt(f.CHG_DATE));
        }
        else {
          d = new Date(
            f.CHG_DATE.substring(0, 4) +
            "-" +
            (parseInt(f.CHG_DATE.substring(4, 6))) +
            "-" +
            f.CHG_DATE.substring(6, 8)
          );
        }
        if (enableDownload) {
          return (
            <a
              key={f.FILE_NUM + "ref"}
              href=""
              onClick={e => {
                handleDownload(e, f);
              }}
            >
              {renderFile(f, d, key)}
            </a>
          );
        } else {
          return renderFile(f, d, key);
        }
      })}
    </div>
  );
}
